import { Record as record } from 'immutable';
import Joi from 'joi';
import _ from 'lodash';

import config from '../config';
import Station from './Station';
import trainTime from '../lib/TrainTime';
import { construct, fields, resolve } from '../helpers/LinkMapper';
import ValidationMixin from './ValidationMixin';
import { serialize, serializers, deserialize, deserializers } from '../helpers/SearchUrls';
import Validation from '../validation.js';

function _minDate () {
    if (config.get('daySaveAbsoluteDateRangeStart')) {
        return trainTime(config.get('daySaveAbsoluteDateRangeStart')).startOf('day');
    }
    return trainTime().add(config.get('daySaveRelativeDateRangeStart'), 'days').startOf('day');
}

function _maxDate () {
    if (config.get('daySaveAbsoluteDateRangeEnd')) {
        return trainTime(config.get('daySaveAbsoluteDateRangeEnd')).endOf('day');
    }
    return trainTime().add(config.get('daySaveRelativeDateRangeEnd'), 'days').endOf('day');
}

const defaults = {
    date: _minDate(),
    origin: new Station(),
    destinationNlc: config.get('daySaveDestinationNlc'),
    adults: 1,
    children: 0
};

class DaySaveSearch extends record(defaults) {
    static fromJSON (json = {}) {
        json = _.defaults(json, { adults: 0, children: 0 });
        return construct(DaySaveSearch, json, {
            date: fields.datetime,
            origin: resolve.as(Station),
            adults: fields.number,
            children: fields.number
        });
    }

    serialize () {
        return serialize({
            adults: serializers.identity,
            children: serializers.identity,
            origin: serializers.station,
            destinationNlc: serializers.identity,
            date: serializers.date
        }, this);
    }

    /**
     * Return a promise that resolves to a new DaySaveSearch, from the url params
     */
    static deserialize (source) {
        const schema = {
            adults: deserializers.int,
            children: deserializers.int,
            origin: deserializers.station,
            date: deserializers.date
        };

        return deserialize(schema, source).then((deserialized) => {
            return new DaySaveSearch(deserialized);
        });
    }

    refreshDates () {
        if (this.date.isBefore(this.minimumDate)) {
            return this.set('date', this.minimumDate);
        }
        return this;
    }

    get minimumDate () {
        return _minDate();
    }

    get maximumDate () {
        return _maxDate();
    }

    getComputedValues () {
        return {
            date: this.date.format(),
            origin: this.origin.nlc
        };
    }

    //Hack for compatibility
    isValid () {
        return this.isComplete();
    }

    getSchema () {
        const dateRange = Joi.date().min(_minDate().format()).max(_maxDate().format());
        const isFuture = Joi.date().min(trainTime().format());
        return {
            date: isFuture.concat(dateRange).required(),
            adults: Joi.number().min(0).max(9).required(),
            children: Joi.number().min(0).max(9).required(),
            origin: Validation.requiredString()
        };
    }
}

Object.assign(DaySaveSearch.prototype, ValidationMixin);

export default DaySaveSearch;



// WEBPACK FOOTER //
// ./src/records/DaySaveSearch.js